import { Tooltip } from "antd";
import { default as React, useEffect, useRef, useState } from "react";
import infoTooltip from "../../assets/icon/infoTooltipIcon.svg";
import { RecorderContext } from "../../store/recorderStore";

export default function InfoAudio({ question }) {
  const { recorderC, dispatchRecorder } = RecorderContext();

  const stopClip = recorderC.isRecording || recorderC.isClipPlaying;
  const [clipPlaying, setClipPlaying] = useState(false);
  const clipRef = useRef(null);
  const infoAudio = question.info_audio;

  useEffect(() => {
    const audioClip = document.getElementById("audioClip");
    audioClip.addEventListener("ended", () => {
      setClipPlaying(false);
    });
    return () => {
      audioClip.removeEventListener("ended", () => {
        setClipPlaying(false);
      });
    };
  }, []);

  useEffect(() => {
    if (clipPlaying) {
      const playPromise = clipRef.current.play();
      if (playPromise !== undefined) {
        playPromise.then((_) => {}).catch((error) => {});
      }
    } else {
      clipRef.current.pause();
    }
  }, [clipPlaying]);

  return (
    <Tooltip
      title={
        question && (
          <span className="info-audio" style={{ color: "#000" }}>
            {question.info}
          </span>
        )
      }
      color="#ffcd19"
    >
      <audio
        id="audioClip"
        ref={clipRef}
        src={
          !!infoAudio
            ? require(`../../assets/audio/infoClip/${infoAudio}.mp3`).default
            : ""
        }
      ></audio>
      <img
        src={infoTooltip}
        alt=""
        style={{ cursor: "pointer" }}
        className=""
        onMouseEnter={() => (stopClip ? undefined : setClipPlaying(true))}
        onMouseLeave={() => setClipPlaying(false)}
      />
    </Tooltip>
  );
}
